define(
	'C3.ShoppingExtensions.WarrantyPopup.View',
	[
		    'SCView'
		,   'c3_shoppingextensions_pdp_warrantypopup.tpl'
		,   'AjaxRequestsKiller'
		,   'GlobalViews.Breadcrumb.View'
		,   'Utils'
		,   'Backbone.CollectionView'
		,   'Facets.CategoryCell.View'
		
		,	'Backbone'
		],
	function(
		   SCViewComponent
		,  c3_shoppingextensions_pdp_warrantypopup_tpl
		,   AjaxRequestsKiller
		,   GlobalViewsBreadcrumbView
		,   Utils
		,   BackboneCollectionView
		,   FacetsCategoryCellView
		,	Backbone
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function WarrantyPopupView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = c3_shoppingextensions_pdp_warrantypopup_tpl;	
			this.application = options.application;
		}

		// Inherit parent instance methods.
		WarrantyPopupView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		WarrantyPopupView.prototype.constructor = WarrantyPopupView;

		WarrantyPopupView.prototype.getContext = function() {
			
			return {
				
			};
		}

		return WarrantyPopupView;
	}

);
